import { render, staticRenderFns } from "./GithubEmbed.vue?vue&type=template&id=69979974&scoped=true"
import script from "./GithubEmbed.vue?vue&type=script&lang=js"
export * from "./GithubEmbed.vue?vue&type=script&lang=js"
import style0 from "./GithubEmbed.vue?vue&type=style&index=0&id=69979974&prod&scoped=true&lang=css"
import style1 from "./GithubEmbed.vue?vue&type=style&index=1&id=69979974&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69979974",
  null
  
)

export default component.exports